// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__3qUkX","heading":"Sidebar_heading__2fEX5","nav":"Sidebar_nav__18KQo","navItem":"Sidebar_navItem__1NryS","active":"Sidebar_active__9wFJE"};